import { useEffect, useState } from 'react'
import { ButtonBase, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { selectProfileStyles as styles } from 'src/components/Layout/components/Header/components/SelectProfile/SelectProfileStyles'
import { ExchangeIcon } from 'src/components/shared/ui/Icons'
import { useLexnetStatusContext } from 'src/contexts/LexnetStatusContext'
import { theme } from 'src/providers/ThemeProvider'

type Props = {
  onClick: () => void
}

export default function SelectProfile({ onClick }: Props): JSX.Element | null {
  const { t } = useTranslation()

  const [showSelector, setShowSelector] = useState(false)
  const { getUsers } = useLexnetStatusContext()

  useEffect(() => {
    const { users } = getUsers()
    const show: boolean = users && users.length > 1
    setShowSelector(show)
  }, [getUsers])

  function openDialog() {
    if (showSelector) {
      onClick()
    }
  }

  return (
    <>
      {showSelector && (
        <ButtonBase sx={styles} focusRipple onClick={openDialog}>
          <Box display="flex" alignItems="center" style={{ margin: '0 7px 0 3px' }}>
            <ExchangeIcon width={16} height={16} color={theme.colors.grey14} />
          </Box>
          {t('components.connection_chips.select_profile')}
        </ButtonBase>
      )}
    </>
  )
}
